import { SearchPageResultsPlaceholderContainer } from "./SearchPageResultsPlaceholderContainer";

export const SearchPageResultsPlaceholderPage = ({ numberOfCards }) => {
	return (
		<div className="search-page-results-placeholder-page">
			<div className="search-page-results-placeholder-page-header">
				<div className="search-page-results-placeholder-page-header-content">
					<div className="search-page-results-placeholder-page-header-content-results placeholder-pulse"></div>
					<div className="search-page-results-placeholder-page-header-content-facet placeholder-pulse"></div>
				</div>
			</div>
			<div className="container">
				<div className="search-page-results-placeholder-page-content">
					<div className="search-page-results-placeholder-page-content-facets">
						<div className="search-page-results-placeholder-page-content-facets-hide-button placeholder-pulse"></div>
						<div className="search-page-results-placeholder-page-content-facets-filters placeholder-pulse"></div>
						<div className="search-page-results-placeholder-page-content-facets-mobile-button placeholder-pulse"></div>
						<div className="search-page-results-placeholder-page-content-facets-mobile-button placeholder-pulse"></div>
					</div>
					<div className="search-page-results-placeholder-page-content-results">
						<SearchPageResultsPlaceholderContainer numberOfCards={numberOfCards} />
					</div>
				</div>
			</div>
		</div>
	);
};
